import {KpiTargetFrequency} from '@store/@types/kpi';

const FrequencyToNumber = {
  [KpiTargetFrequency.DAILY]: 1,
  [KpiTargetFrequency.WEEKLY]: 2,
  [KpiTargetFrequency.MONTHLY]: 3,
  [KpiTargetFrequency.QUARTERLY]: 4,
  [KpiTargetFrequency.ANNUALLY]: 5,
};

export const frequencyComparator = (_a: KpiTargetFrequency, _b: KpiTargetFrequency): number => {
  const a = FrequencyToNumber[_a];
  const b = FrequencyToNumber[_b];

  return a > b ? 1 : a === b ? 0 : -1;
};
